import { Component } from '@angular/core';

@Component({
    selector: 'canvas-admin-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {
}
